<adminui-dialog [title]="message()['headerHiThere'] + ', ' + username()" [type]="'info'" (dismiss)="close()">
    <p style="font-size:larger">{{message()['infoPart1']}}</p>
    <p><img alt="" src="../../assets/images/edit-tutorial.png" width="300px"></p>
    <p style="font-size:larger">{{message()['infoPart2']}}</p>
    <p style="font-size:larger">{{message()['infoPart3']}}</p>
    <ng-container dialogFooter>
        <div class="col p-0">
            <button type="button" class="btn btn-default" (click)="close()">{{message()['buttonClose']}}</button>
        </div>
        <button type="button" class="btn btn-primary" cdkFocusInitial
            (click)="ok()">{{message()['buttonVisitHelp']}}</button>
    </ng-container>
</adminui-dialog>
